import { DataBean } from "../DataBean";

export class UBLItemGenerate extends DataBean {



    public async getUblInvoiceCatalogForStore(idAccountSupplier: any, year: any, month: any, state: any, documentType: any, idDocument: any, documentDate: any, idAccountantConcept: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getUblInvoiceCatalogForStore_Number_Number_Number_Number_String_Number_java.util.Date_Number_Number_Number", [idAccountSupplier, year, month, state, documentType, idDocument, documentDate, idAccountantConcept, page, recordsPerPage]);
    }

}
